import { render, staticRenderFns } from "./Super.vue?vue&type=template&id=f27a0c10&"
import script from "./Super.vue?vue&type=script&lang=ts&"
export * from "./Super.vue?vue&type=script&lang=ts&"
import style0 from "./Super.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports